import { API_URL } from '../../../app-config/constants';
import type ExperimentBranchesDto from '../../../types/ExperimentBranchesDto';
import type ExperimentDto from '../../../types/ExperimentDto';
import type { ExperimentKeys } from '../../react/features/ExperimentObserver/ExperimentCreate/ExperimentForm';
import { get, patch, post } from '../request';

const ENTRY = `${API_URL}/experiment-observer`;

getExperiment.operation = 'READ';
export function getExperiment(codeId: string): Promise<ExperimentDto> {
    return get(`${ENTRY}/experiments/${codeId}`);
}

createExperiment.operation = 'CREATE';
export function createExperiment(
    payload: Omit<ExperimentDto, 'status' | 'id' | 'createdAt' | 'permissions' | 'removedUsers'>
): Promise<ExperimentDto> {
    return post(`${ENTRY}/experiments`, { postData: payload });
}

assignToBranches.operation = 'NO_OPERATION';
export function assignToBranches(userIds: string[], experimentOption: ExperimentKeys): Promise<ExperimentBranchesDto> {
    return post(`${ENTRY}/assign-to-branches`, { postData: { userIds, experimentOption } });
}

updateExperiment.operation = 'COMMAND';
export function updateExperiment(
    codeId: string,
    payload: Partial<Pick<ExperimentDto, 'status' | 'name' | 'description'>>
): Promise<ExperimentDto> {
    return patch(`${ENTRY}/experiments/${codeId}`, { postData: payload });
}

removeCompanyFromExperiment.operation = 'COMMAND';
export function removeCompanyFromExperiment(codeId: string, companyId: string): Promise<ExperimentDto> {
    return post(`${ENTRY}/experiments/${codeId}/remove-company?companyId=${companyId}`);
}
